import { LocalParking } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, Typography } from '@mui/material';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/botao.css';
import ReactComponent from '../ReactComponent';
import PresidenteSessao from './PresidenteSessao';

class ModalPresidenteSessao extends ReactComponent {
    aberto = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            aberto: observable,
            sessoes: computed,
            handleClickIconePresidente: action,
            handleClickConfirmar: action,
            fecharDialog: action,
            todosPresidentesPreenchidos: computed,
            callbackAutoCompletePresidente: action
        });
    }

    get sessoes() {
        return this.sessaoStore?.sessaoSelecionada?.sessoes || [];
    }

    handleClickIconePresidente = () => {
        this.aberto = true;
    };

    handleClickConfirmar = async () => {
        await this.gravarPresidentes();
        this.fecharDialog();
    };

    fecharDialog = () => {
        this.aberto = false;
    };

    async gravarPresidentes() {
        for (let index in this.sessoes.slice()) {
            let sessao = this.sessoes[index];
            if (sessao.presidente) {
                await this.sessaoService.gravarPresidente(sessao.id, sessao.presidente);
            }
            this.atualizarProcessosSIJ(sessao, sessao.presidente);
        }
        this.mensagemStore.abrirMensagemSucesso('Operação realizada com sucesso.');
    }

    atualizarProcessosSIJ(sessao, presidente) {
        if (this.salaSessaoStore.isSessaoSIJ(sessao.id)) {
            let processos = this.salaSessaoStore.getProcessosSessao(sessao.id);
            processos = processos.filter(
                (registro) => !SituacaoJulgamentoProcessoBusiness.isProcessoApreciado(registro?.resultadoJulgamento)
            );
            processos.forEach((registro) => {
                registro.presidente = presidente;
            });
        }
    }

    get todosPresidentesPreenchidos() {
        for (let index in this.sessoes.slice()) {
            if (!this.sessoes[index].presidente) {
                return false;
            }
        }
        return true;
    }

    callbackAutoCompletePresidente = (option, idSessao) => {
        let sessaoSelecionada = this.sessoes.find((sessao) => sessao.id === idSessao);
        if (sessaoSelecionada) {
            sessaoSelecionada.presidente = option ? option.valor : null;
        }
    };

    render() {
        return (
            <>
                <Tooltip
                    title={<Typography>Editar presidente padrão da sessão</Typography>}
                    placement="top-start"
                >
                    <Box
                        style={{
                            display: 'flex',
                            margin: '8px',
                            cursor: 'pointer',
                            fill: this.observableProps.corIcone
                        }}
                        className="corBotaoAmarelo"
                        onClick={this.handleClickIconePresidente}
                    >
                        <LocalParking />
                    </Box>
                </Tooltip>
                {this.aberto && (
                    <Dialog
                        open={this.aberto}
                        maxWidth="xl"
                        onClose={this.fecharDialog}
                    >
                        <DialogTitle style={{ paddingBottom: '6px' }}>Editar presidente da sessão</DialogTitle>
                        <DialogContent style={{ paddingBottom: '6px' }}>
                            <PresidenteSessao callbackAutoComplete={this.callbackAutoCompletePresidente} />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={this.fecharDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={this.handleClickConfirmar}
                                color="primary"
                                variant="outlined"
                                endIcon={<SaveIcon />}
                            >
                                Salvar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ModalPresidenteSessao));
